export const GA_TRACKING_ID = 'G-HTEZ177JQ6';

export const gtagEvent = ({ action, category, label }) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
        });
    }
};


// Your existing GA tracking ID
// export const GA_TRACKING_ID = 'G-HTEZ177JQ6';

// /**
//  * Standard GA4 event tracking (still useful for analytics)
//  */
// export const gtagEvent = ({ action, category, label }) => {
//     if (typeof window !== 'undefined' && window.gtag) {
//         window.gtag('event', action, {
//             event_category: category,
//             event_label: label,
//         });
//     }
// };

// /**
//  * Google Ads Conversion Tracking
//  * @param {string} sendToId - The 'send_to' conversion ID (e.g., 'AW-XXXXXX/abc123')
//  * @param {string} [url] - Optional URL to redirect to after tracking
//  */
// export const gtagReportConversion = (sendToId, url) => {
//     if (typeof window !== 'undefined' && window.gtag) {
//         const callback = () => {
//             if (url) {
//                 window.location = url;
//             }
//         };

//         window.gtag('event', 'conversion', {
//             send_to: sendToId,
//             transaction_id: '',
//             event_callback: callback,
//         });

//         return false; // For form submissions or inline click handlers
//     }
// };
